import { Banner } from '@reflex/ui/components/shared/Banner';
import { PanelTitle, PageDescription } from '@reflex/ui/components/layout/Typography';
import type { IntegrationSecretStatus } from '@/lib/types';

export function MissingSecretsBanner({
  integrations,
}: {
  integrations: IntegrationSecretStatus[];
}) {
  const withMissing = integrations.filter((i) => i.missingRequired.length > 0);
  if (withMissing.length === 0) return null;

  const totalMissing = withMissing.reduce((acc, i) => acc + i.missingRequired.length, 0);

  return (
    <Banner intent="warning">
      <PanelTitle as="h2" size="sm">
        {totalMissing} missing secret{totalMissing !== 1 ? 's' : ''} across {withMissing.length}{' '}
        integration{withMissing.length !== 1 ? 's' : ''}
      </PanelTitle>
      <PageDescription className="mt-0.5 text-xs opacity-80">
        {withMissing.map((i) => `${i.name} (${i.missingRequired.length})`).join(' · ')}
      </PageDescription>
    </Banner>
  );
}
